/** Real user quotes — only add entries after written permission. */
export const USER_TESTIMONIALS = [
  {
    quote:
      'Running the model against a historical time series is an important capability. I value it. Running four choices of withdrawal strategy is great.',
    attribution: 'Laurie S.'
  },
  {
    quote:
      'I like that you can quickly and easily change the inputs and re-run the what-if calculations. The staggered retirement age option is great too.',
    attribution: 'Robert C.'
  },
  {
    quote: 'This simulator is very informative and intuitive.',
    attribution: 'Matthew N.'
  }
];
